import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../CSS/Contact.css";
import WhatsAppContact from "../components/WhatsAppContact";
import axios from "axios";
import NavBar from "../components/NavBar";
import Header from "../components/header";
import Footer from "../components/Footer";
import AlertBox from "../components/Alert";
import Loader from "../components/Loader";
import effect1 from "../assets/effect1.png";

const ContactBanner =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195116/contactBanner_akxiuw_iogkcr.webp";
const ContactCar =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195114/contact_car_j0szbt_tebtzr.webp";

const ContactUs = () => {
  const initialValues = {
    fname: "",
    lname: "",
    phone: "",
    email: "",
    message: "",
  };
  const [formData, setFormData] = useState(initialValues);
  const [isLoader, setIsLoader] = useState(false);
  const [isApiResult, setIsApiResult] = useState({
    show: false,
    type: 1,
    message: "",
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    if (
      formData.fname === "" ||
      formData.lname === "" ||
      formData.email === "" ||
      formData.message === ""
    ) {
      setIsLoader(false);
      setIsApiResult({
        show: true,
        type: 2,
        message: "Please fill required fields.",
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://test.ecsprovider.com/api/contact-us",
        {
          fname: formData.fname,
          lname: formData.lname,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setIsLoader(false);
      setIsApiResult({
        show: true,
        type: 1,
        message: response.data.result,
      });
      setFormData(initialValues);
    } catch (error) {
      setIsLoader(false);
      const errorMessage =
        error.response?.data?.result ||
        "Something went wrong. Try again later.";
      setIsApiResult({
        show: true,
        type: 2,
        message: errorMessage,
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <div className="main_contact_container" style={{ backgroundColor: "#FFF" }}>
      {isLoader && <Loader />}
      <WhatsAppContact number="+966532022290" />
      <NavBar cname="Contact Us"></NavBar>
      <Header heading="Get in Touch" banner={ContactBanner}></Header>
      <img src={effect1} className="effect1" alt="effect-img1" />
      <Container className="main_contact_body">
        <h1 className="heading">
          Contact Us for Unmatched <span>Service and Support</span>
        </h1>
        <p className="description">
          Have questions about our services or ready to book your next luxury
          travel experience? Don't hesitate to reach out to us at Lothanrides. Our
          dedicated team is here to provide you with the personalized assistance
          and support you need to make your journey extraordinary.
        </p>
        <Row className="contact_form_container">
          <Col md="6">
            <div className="contact_form">
              <form onSubmit={handleOnSubmit}>
                <input
                  type="text"
                  name="fname"
                  placeholder="First Name"
                  value={formData.fname}
                  required
                  onChange={handleOnChange}
                  className="contact_input"
                />
                <br />
                <input
                  type="text"
                  name="lname"
                  placeholder="Last Name"
                  required
                  value={formData.lname}
                  onChange={handleOnChange}
                  className="contact_input"
                />
                <br />
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  required
                  value={formData.phone}
                  onChange={handleOnChange}
                  className="contact_input"
                />
                <br />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleOnChange}
                  required
                  className="contact_input"
                />
                <br />
                <textarea
                  name="message"
                  placeholder="Message"
                  className="contact_message"
                  required
                  value={formData.message}
                  onChange={handleOnChange}
                />
                <br />
                <button
                  type="submit"
                  className="contact_form_button"
                >
                  Submit
                </button>
              </form>
            </div>
            <AlertBox
              isShow={isApiResult.show}
              type={isApiResult.type}
              message={isApiResult.message}
            />
          </Col>
          <Col md="6">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.0!2d46.63306602883544!3d24.771419096094405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQ2JzE3LjEiTiA0NsKwMzcnNTkuMCJF!5e0!3m2!1sen!2s!4v1709574527218!5m2!1sen!2s"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              referrerpolicy="no-referrer-when-downgrade"
              className="contact_us_map"
              title="Lothanrides Office Location Map"
            />
          </Col>
        </Row>
      </Container>
      <div className="contact_details_us">
        <Container>
          <div className="contact_info_box">
            <div className="detail_sec_1">
              <div className="detail_info_box">
                <p className="title">Phone :</p>
                <p className="value">+966 53 202 2290</p>
              </div>
              <div className="detail_info_box_2">
                <p className="title">Email :</p>
                <p className="value">info@lothanrides.com</p>
              </div>
            </div>
            {/* <div className="detail_sec_2">
              <div className="detail_info_box">
                <p className="title">Registered Office:</p>
                <p className="value">
                  Lothanrides Provider Pvt. Ltd. Khadiman Rd,
                  beside Near State Bank Of India, 788806, Badarpur, Assam,
                  India
                </p>
              </div>
            </div> */}
            <div className="detail_sec_2">
              <div className="detail_info_box">
                <p className="title">Corporate Office:</p>
                <p className="value">
                Kingdom of Saudi Arabia - Riyadh - Al-Aqeeq District
                </p>
              </div>
            </div>
          </div>
        </Container>
        <div className="contact_car_image">
          <img src={ContactCar} alt="contact car" />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
